import { useActivityTemplate } from "PFApp/activities/show/hooks/use_activity_template";
import { useFiltersV2Store } from "PFApp/components/filters_v2";
import { useBufferedFilter } from "PFApp/components/filters_v2/hooks/use_buffered_filter";
import { FiltersV2AvailabilityThresholdBox } from "PFApp/components/filters_v2/parts/filters_v2_availability_threshold_box";
import { Accordion } from "PFComponents/accordion";
import { Button } from "PFComponents/button";
import { KnownFiltersV2 } from "PFTypes/filters_v2";
import { useTranslation } from "react-i18next";
import { useToggle } from "react-use";

import commonCss from "../../side_filters.module.scss";
import { AccordionHeader } from "../accordion_header";
import { AvailabilitySidePanel } from "./availability_side_panel";

type AvailabilityFilterProps = {
  disabled: boolean;
  scope: number;
};

const AvailabilityFilterContent = ({ disabled, scope }: AvailabilityFilterProps) => {
  const { t } = useTranslation("activities", { keyPrefix: "show.sidePanel.filters" });
  const template = useActivityTemplate();
  const [isAvailabilityPanelOpen, toggleIsAvailabilityPanelOpen] = useToggle(false);

  const { restore, clear, canRestore, canClear } = useBufferedFilter(KnownFiltersV2.Availability);

  const handleClear = (event) => {
    event.stopPropagation();
    clear();
  };

  const handleRestore = (event) => {
    event.stopPropagation();
    restore();
  };

  return (
    <section className={commonCss.section}>
      <Accordion
        header={
          <AccordionHeader
            title={t("availability")}
            disabled={disabled}
            clearTitle={t("clearAvailabilityFilter")}
            restoreTitle={t("restoreAvailabilityFilter")}
            onClear={canClear && handleClear}
            onRestore={canRestore && handleRestore}
          />
        }
        headerVariant="bodyBold"
        headerFullWidth
        iconSet="chevron"
      >
        <FiltersV2AvailabilityThresholdBox scope={scope} template={template} disabled={disabled} />
        <Button
          text={t("editAvailabilityRequirements")}
          kind="text"
          onClick={toggleIsAvailabilityPanelOpen}
        />
      </Accordion>
      <AvailabilitySidePanel
        show={isAvailabilityPanelOpen}
        disabled={disabled}
        onClose={() => toggleIsAvailabilityPanelOpen(false)}
      />
    </section>
  );
};

export const ActivityPageAvailabilityFilter = (props: AvailabilityFilterProps) => {
  const template = useActivityTemplate();
  const hasAvailabilityFilter = useFiltersV2Store(
    (state) => !!state.mainFilters[KnownFiltersV2.Availability]
  );

  if (!template || !hasAvailabilityFilter) {
    return null;
  }

  return <AvailabilityFilterContent {...props} />;
};
